// extracted by mini-css-extract-plugin
export default {"experiences":"exp_experiences__jSzf6","experienceList":"exp_experienceList__KF0Kt","app-content":"exp_app-content__-HFUc"};